import gtm from './gtm';

export default {
  initialize: () => {
    gtm.initialize();
  }
};
